import React from 'react';
import { cn } from '../../utils/utils';

const Label = React.forwardRef(({ className, ...props }, ref) => (
  <label
    ref={ref}
    className={cn("text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-zinc-300", className)}
    {...props}
  />
));
Label.displayName = "Label";

export { Label };
